// Port de app/(tabs)/estoque.tsx.
import { Carregando } from "@/app/Carregando";
import { useIsFocused } from "@/navigation";
import { lazy } from "react";

const EstoqueScreen = lazy(() => import("@/screens/Estoque"));

export default function EstoqueRoute() {
  const focused = useIsFocused();
  return focused ? (
    <Carregando>
      <EstoqueScreen />
    </Carregando>
  ) : null;
}
